// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_swiss_notice_main_div {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.user_swiss_notice_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_swiss_notice_column {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.user_swiss_notice_item {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.user_swiss_notice_label {
    font-size: 13px;
    font-weight: 400;
    color: var(--text-muted);
}

.user_swiss_notice_status {
    margin: 0;
    font-size: 14px;
    color: var(--text-muted);
}

.user_swiss_notice_status_error {
    color: #d93025;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserSwissNotice/userSwissNotice.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".user_swiss_notice_main_div {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    gap: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.user_swiss_notice_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_swiss_notice_column {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.user_swiss_notice_item {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.user_swiss_notice_label {\n    font-size: 13px;\n    font-weight: 400;\n    color: var(--text-muted);\n}\n\n.user_swiss_notice_status {\n    margin: 0;\n    font-size: 14px;\n    color: var(--text-muted);\n}\n\n.user_swiss_notice_status_error {\n    color: #d93025;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
